import * as cn from "classnames";
import * as React from "react";
import Text from "../../../../shared/components/text";
import * as styles from "./styles.css";
var BookingPrice = function (_a) {
    var children = _a.children, labelBefore = _a.labelBefore, labelAfter = _a.labelAfter, className = _a.className, originalPrice = _a.originalPrice;
    return (React.createElement("div", { className: cn(styles.bookingPrice, className) },
        labelBefore &&
            React.createElement("span", { className: cn(styles.bookingPriceLabel, styles.bookingPriceLabelBefore) }, labelBefore),
        originalPrice &&
            React.createElement("span", { className: cn(styles.bookingPriceAmount, styles.bookingOriginalPriceAmount) }, originalPrice),
        React.createElement(Text.AccentRed, { className: styles.bookingPriceAmount }, children),
        labelAfter &&
            React.createElement("span", { className: cn(styles.bookingPriceLabel, styles.bookingPriceLabelAfter) }, labelAfter)));
};
export default BookingPrice;



//////////////////
// WEBPACK FOOTER
// ./app/modules/pois/patterns/booking/bookingPrice.tsx
// module id = N28R
// module chunks = 2